export const CURRENCY_OPTIONS = [
  { label: 'ARS – Peso argentino', value: 'ARS' },
  { label: 'USD – Dólar estadounidense', value: 'USD' },
  { label: 'EUR – Euro', value: 'EUR' },
  { label: 'BRL – Real brasileño', value: 'BRL' },
  { label: 'UYU – Peso uruguayo', value: 'UYU' },
];

export const getCurrencyName = (currency: string): string => {
  return CURRENCY_OPTIONS.find((option) => option.value === currency)?.label || currency;
};
